<template>
  <div>
    <transition name="fade" v-if="display.pricingTable" mode="out-in">
      <PricingTable @display-component="toggleDisplay" :company-record="company_record_id" :user-record="user_record_id"/>
    </transition>
    <transition name="fade" v-if="display.registerAccount" mode="out-in">
      <RegisterAccount @display-component="toggleDisplay"/>
    </transition>
  </div>
</template>

<script>
import RegisterAccount from "@/components/RegisterAccount.vue";
import PricingTable from "@/components/PricingTable.vue";

export default {
  components: { RegisterAccount, PricingTable },
  data() {
    return {
      company_record_id: "",
      user_record_id: "",
      display: {
        registerAccount: true,
        pricingTable: false
      }
    };
  },
  methods: {
    toggleDisplay(eventMessage) {
      switch (eventMessage.component) {
        case "pricingTable":
          this.company_record_id = eventMessage.company_record_id;
          this.user_record_id = eventMessage.user_record_id;
          this.display.registerAccount = false;
          this.display.pricingTable = true;
          break;
      }
    }
  }
};
</script>

<style scoped>
.fade-enter-active {
  transition: opacity 1.5s;
}
.fade-leave-active {
  opacity: 0;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
